import { render } from "./GuardNotifications.vue?vue&type=template&id=1a98f42d"
import script from "./GuardNotifications.vue?vue&type=script&lang=js"
export * from "./GuardNotifications.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__